const __WEBPACK_NAMESPACE_OBJECT__ = require("html-favicon-webpack-plugin");